import React from 'react'
import * as UI from 'ui'
import { FlexGrid } from 'ui'
import { Translator } from '@morningtrain/react-translations'
import { Collection, ForEachModel, ModelWithForm, WhenModel } from '@morningtrain/react-resources'
import AdminPage from 'pages/app/AdminPage'
import ModelValueTitle from 'widgets/ModelValueTitle'
import { ModelValueFilter } from '@morningtrain/react-filters'
import { FileCard } from 'ui/cards/FileCard'
import { SelectedDepartmentFilter } from 'support/filters'

export default function ViewEmployeeFilesTag () {
  return (
    <AdminPage>
      <Translator namespace='files.employee_files'>
        <ModelWithForm resourceName='files.tags' operationName='read'>
          <WhenModel>
            <UI.PageHeader title={<ModelValueTitle name='name' />} />
            <Collection resourceName='files.files'>
              <ModelValueFilter name='file_tag_id' modelKey='id' />
              <SelectedDepartmentFilter />

              <FlexGrid className='mt-4 mb-12' responsive={{ xl: 3, md: 2 }}>
                <ForEachModel>
                  <FileCard />
                </ForEachModel>
              </FlexGrid>
            </Collection>
          </WhenModel>
        </ModelWithForm>
      </Translator>
    </AdminPage>
  )
}
